function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 24,
  fill: "#8CC059"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6204 16.6201H33.8904V37.7101C33.8904 38.2406 33.6796 38.7493 33.3046 39.1243C32.9295 39.4994 32.4208 39.7101 31.8904 39.7101H15.6104C15.0799 39.7101 14.5712 39.4994 14.1961 39.1243C13.8211 38.7493 13.6104 38.2406 13.6104 37.7101V16.6201H13.6204Z",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M14.1402 11.0501V9.88006C14.1389 9.76412 14.1607 9.64909 14.2045 9.54172C14.2482 9.43435 14.313 9.3368 14.395 9.25482C14.4769 9.17283 14.5745 9.10806 14.6819 9.06431C14.7892 9.02056 14.9043 8.99872 15.0202 9.00006H32.1702C32.2861 8.99872 32.4012 9.02056 32.5085 9.06431C32.6159 9.10806 32.7135 9.17283 32.7954 9.25482C32.8774 9.3368 32.9422 9.43435 32.9859 9.54172C33.0297 9.64909 33.0515 9.76412 33.0502 9.88006V10.9901",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M34.31 11.26H12.88C12.394 11.26 12 11.654 12 12.14V15.66C12 16.146 12.394 16.54 12.88 16.54H34.31C34.796 16.54 35.19 16.146 35.19 15.66V12.14C35.19 11.654 34.796 11.26 34.31 11.26Z",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M28.8203 13.29V16.29",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M25.2402 13.29V16.29",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "M21.6504 13.29V16.29",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "M18.0703 13.29V16.29",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "M14.48 13.29V16.29",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "M32.4102 13.29V16.29",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "M13.6704 21.24V34.75H33.7804V21.24H13.6704ZM27.9204 28.24C27.9204 28.5052 27.8151 28.7596 27.6275 28.9471C27.44 29.1346 27.1856 29.24 26.9204 29.24H25.1404V31.02C25.1404 31.2852 25.0351 31.5396 24.8475 31.7271C24.66 31.9146 24.4056 32.02 24.1404 32.02H23.5904C23.3252 32.02 23.0708 31.9146 22.8833 31.7271C22.6958 31.5396 22.5904 31.2852 22.5904 31.02V29.33H20.7904C20.5252 29.33 20.2708 29.2246 20.0833 29.0371C19.8958 28.8496 19.7904 28.5952 19.7904 28.33V27.78C19.7904 27.5148 19.8958 27.2604 20.0833 27.0729C20.2708 26.8853 20.5252 26.78 20.7904 26.78H22.5604V24.93C22.5604 24.6648 22.6658 24.4104 22.8533 24.2229C23.0408 24.0353 23.2952 23.93 23.5604 23.93H24.1104C24.3756 23.93 24.63 24.0353 24.8175 24.2229C25.0051 24.4104 25.1104 24.6648 25.1104 24.93V26.71H26.8804C27.1456 26.71 27.4 26.8153 27.5875 27.0029C27.7751 27.1904 27.8804 27.4448 27.8804 27.71L27.9204 28.24Z",
  fill: "white",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "M26.91 26.7102H25.14V24.9302C25.14 24.665 25.0347 24.4106 24.8471 24.2231C24.6596 24.0355 24.4053 23.9302 24.14 23.9302H23.59C23.3248 23.9302 23.0705 24.0355 22.8829 24.2231C22.6954 24.4106 22.59 24.665 22.59 24.9302V26.7102H20.79C20.5248 26.7102 20.2705 26.8155 20.0829 27.0031C19.8954 27.1906 19.79 27.445 19.79 27.7102V28.2602C19.79 28.5254 19.8954 28.7797 20.0829 28.9673C20.2705 29.1548 20.5248 29.2602 20.79 29.2602H22.56V31.0402C22.56 31.3054 22.6654 31.5597 22.8529 31.7473C23.0405 31.9348 23.2948 32.0402 23.56 32.0402H24.11C24.3753 32.0402 24.6296 31.9348 24.8171 31.7473C25.0047 31.5597 25.11 31.3054 25.11 31.0402V29.3302H26.88C27.1453 29.3302 27.3996 29.2248 27.5871 29.0373C27.7747 28.8497 27.88 28.5954 27.88 28.3302V27.7802C27.8895 27.6456 27.8717 27.5104 27.8276 27.3829C27.7835 27.2554 27.714 27.1381 27.6234 27.0382C27.5328 26.9382 27.4228 26.8576 27.3003 26.8012C27.1777 26.7449 27.0449 26.7139 26.91 26.7102V26.7102Z",
  stroke: "#292929",
  strokeWidth: 1.5,
  strokeLinejoin: "round"
});

function SvgMedication(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedication);
export default __webpack_public_path__ + "static/media/medication.a26bc4de.svg";
export { ForwardRef as ReactComponent };